import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Órdenes',
      value: stats?.total,
      icon: 'FileText',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'En Proceso',
      value: stats?.inProgress,
      icon: 'Clock',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Listas',
      value: stats?.ready,
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Entregadas Hoy',
      value: stats?.deliveredToday,
      icon: 'Package',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4 md:mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-elevation-2 p-4 md:p-6 hover:shadow-elevation-3 transition-smooth"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
            <span className="text-2xl md:text-3xl font-bold text-foreground">
              {stat?.value}
            </span>
          </div>
          <p className="text-sm md:text-base text-muted-foreground">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default OrderStats;